/**
 * @module lib/election/switching-hands
 */
import tgamConfig from "config/tgam";
import { getById, getProp, qs } from "utils/utils";
import ee from "lib/eventemitter";
import { errorStateHideFeature, errorStateShowFeature } from "lib/election/error-state";
import { getStatus } from "./lead-data-helpers";
import { getParty, getNumDifference } from "./helpers";

/**
 * @method init
 * @description Initialize the switching hands component.
 */

export default function init() {
  const container = getById("js-election-switching-hands-container");
  if (!container) {
    return;
  }
  const itemsContainer = qs(".js-election-switching-hands-items", container);

  ee.on("election:leading-data-failed", () => {
    errorStateHideFeature(container);
  });


  ee.on("election:leading-data", data => {
    errorStateShowFeature(container);
    const electionComplete = getStatus(data) === "complete";
    const items = data.Leading.Party.map(party => {
      return generateItemMarkup(party, electionComplete, getProp(tgamConfig, "meta.electionYear", "2021")
      );
    }).join("");
    itemsContainer.innerHTML = items;
  });
}

/**
 * @method generateItemMarkup
 * @description Generate the markup for one party.
 * @param {Object} partyData
 * @param {Boolean} electionComplete - true when election is completed
 * @param {String} electionYear - election year whose data is being displayed
 * @returns {HTMLElement} markup for one item in switching hands.
 */
function generateItemMarkup(partyData, electionComplete, electionYear) {
  const partyName = getProp(partyData, "Name").toLowerCase();
  const { party = "", partyClassModifier = "", previousElection = 0 } = getParty(partyName, electionYear);
  const currentElection = Number(getProp(partyData, "LeadingElected", 0));

  const leadingNum = electionComplete
    ? currentElection - previousElection
    : getNumDifference(partyData);

  // Don't update `*-data__2015/2019` style classes, they're defined in Panther. No "year" value is displayed in the UI.
  return `
  <div class="c-election-switching-hands__item">
    <div class="c-election-switching-hands__item-main c-election-switching-hands__item--${partyClassModifier}">
      <span class="c-election-switching-hands__item-main__party">${party}</span>
      <span class="c-election-switching-hands__item-main__results">${leadingNum > 0 ? "+" : ""}${leadingNum}</span>
    </div>
    <div class="c-election-switching-hands__item-data">
      <span class="c-election-switching-hands__item-data__2015"> Before: <span class="c-election-switching-hands__item-data__votes c-election-switching-hands__item--${partyClassModifier}">${previousElection}</span>
      </span>
      <span class="c-election-switching-hands__item-data__2019"> After: <span class="c-election-switching-hands__item-data__votes c-election-switching-hands__item--${partyClassModifier}">${currentElection}</span>
      </span>
    </div>
  </div>`;
}
